document.addEventListener('DOMContentLoaded', () => {
  const isHome =
    document.body.dataset.template === 'index' ||
    window.location.pathname === '/';

  if (!isHome) return;

  const header = document.getElementById('header-component');
  const headerLogoAnchor = document.getElementById('header-logo-anchor');
  const heroLogoOrigin = document.getElementById('hero-logo-origin');

  if (!header || !headerLogoAnchor || !heroLogoOrigin) return;

  const defaultLogoElement = headerLogoAnchor.querySelector('.header-logo__image-container--default img');
  const transparentLogoElement = headerLogoAnchor.querySelector('.header-logo__image-container--transparent img');

  if (!defaultLogoElement || !transparentLogoElement) return;

  const whiteSrc =
    transparentLogoElement.currentSrc ||
    transparentLogoElement.getAttribute('src');

  const blackSrc =
    defaultLogoElement.currentSrc ||
    defaultLogoElement.getAttribute('src');

  if (!whiteSrc || !blackSrc) return;

  const overlay = document.createElement('div');
  overlay.className = 'home-logo-overlay';

  overlay.innerHTML = `
    <div class="home-logo-overlay__inner">
      <img class="home-logo-overlay__image home-logo-overlay__image--white" src="${whiteSrc}" alt="">
      <img class="home-logo-overlay__image home-logo-overlay__image--black" src="${blackSrc}" alt="">
    </div>
  `;

  document.body.appendChild(overlay);

  const whiteLogo = overlay.querySelector('.home-logo-overlay__image--white');
  const blackLogo = overlay.querySelector('.home-logo-overlay__image--black');

  let ticking = false;
  let startRect = null;
  let endRect = null;
  let heroEnd = 0;
  let transitionDistance = 240;
  let isMobile = window.matchMedia('(max-width: 749px)').matches;

  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  const lerp = (a, b, t) => a + (b - a) * t;
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  function getRect(el) {
    return el.getBoundingClientRect();
  }

  function getHeaderLogoTargetRect() {
    const anchorRect = getRect(headerLogoAnchor);
    const visibleImg =
      headerLogoAnchor.querySelector('.header-logo__image-container--default img') ||
      headerLogoAnchor.querySelector('.header-logo__image-container--transparent img');

    if (!visibleImg) return anchorRect;

    const imgRect = visibleImg.getBoundingClientRect();
    return imgRect.width > 0 && imgRect.height > 0 ? imgRect : anchorRect;
  }

  function getHeroSectionBottom() {
    const heroSection = heroLogoOrigin.closest('.hero');
    if (!heroSection) return heroLogoOrigin.getBoundingClientRect().bottom + window.scrollY;
    return heroSection.getBoundingClientRect().bottom + window.scrollY;
  }

  function refreshMetrics() {
    isMobile = window.matchMedia('(max-width: 749px)').matches;

    startRect = getRect(heroLogoOrigin);
    endRect = getHeaderLogoTargetRect();
    heroEnd = getHeroSectionBottom();

    if (isMobile) {
      transitionDistance = Math.max(400, Math.min(700, window.innerHeight * 0.55));
    } else {
      transitionDistance = Math.max(700, Math.min(1200, heroEnd * 0.6));
    }
  }

  function showOverlayAtTop() {
    if (!startRect) return;

    overlay.classList.remove('is-hidden');

    overlay.style.left = `${startRect.left}px`;
    overlay.style.top = `${startRect.top}px`;
    overlay.style.width = `${startRect.width}px`;
    overlay.style.height = `${startRect.height}px`;

    whiteLogo.style.opacity = '1';
    blackLogo.style.opacity = '0';

    document.body.classList.add('logo-transition-active');
    document.body.classList.remove('header-logo-transition-done');
  }

  function updateOverlay() {
    ticking = false;
    if (!startRect || !endRect) return;

    const scrollY = window.scrollY || window.pageYOffset || 0;

    if (scrollY <= 2) {
      refreshMetrics();
      showOverlayAtTop();
      return;
    }

    const rawProgress = clamp(scrollY / transitionDistance, 0, 1);
    const progress = easeOutCubic(rawProgress);

    const left = lerp(startRect.left, endRect.left, progress);
    const top = lerp(startRect.top, endRect.top, progress);
    const width = lerp(startRect.width, endRect.width, progress);
    const height = lerp(startRect.height, endRect.height, progress);

    overlay.style.left = `${left}px`;
    overlay.style.top = `${top}px`;
    overlay.style.width = `${width}px`;
    overlay.style.height = `${height}px`;

    const solidThreshold = isMobile
      ? Math.max(40, heroEnd - header.offsetHeight - 10)
      : heroEnd - header.offsetHeight - 20;

    const colorWindow = isMobile ? 50 : 80;
    const colorProgress = clamp(
      (scrollY - (solidThreshold - colorWindow)) / colorWindow,
      0,
      1
    );

    whiteLogo.style.opacity = `${1 - colorProgress}`;
    blackLogo.style.opacity = `${colorProgress}`;

    if (rawProgress >= 0.995) {
      overlay.classList.add('is-hidden');
      document.body.classList.remove('logo-transition-active');
      document.body.classList.add('header-logo-transition-done');
    } else {
      overlay.classList.remove('is-hidden');
      document.body.classList.add('logo-transition-active');
      document.body.classList.remove('header-logo-transition-done');
    }
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateOverlay);
  }

  function rebuild() {
    refreshMetrics();
    updateOverlay();
  }

  rebuild();

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', rebuild);
  window.addEventListener('orientationchange', () => {
    setTimeout(rebuild, 120);
  });
  window.addEventListener('load', () => {
    setTimeout(rebuild, 80);
  });
  window.addEventListener('pageshow', rebuild);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) rebuild();
  });
  document.addEventListener('touchend', () => {
    if ((window.scrollY || 0) <= 2) {
      rebuild();
    }
  }, { passive: true });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      setTimeout(rebuild, 80);
    });
  }
});